<template>
  <v-card>
    <v-card-title>
      {{ $t('administration.personneMorale.cotisable.title') }}
      <v-spacer />
      <dialogRecherchePersonneMorale
        ref="dialogRecherchePersonneMorale"
        :subtitle="
          $t('administration.personneMorale.cotisable.dialog.description')
        "
        @input="add"
      />
    </v-card-title>
    <v-card-subtitle>
      {{ $t('administration.personneMorale.cotisable.sub') }}
    </v-card-subtitle>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" md="10">
          <v-text-field
            v-model="search"
            :label="$t('administration.personneMorale.cotisable.list.search')"
            filled
            single-line
            hide-details
            clearable
            append-icon="search"
          />
        </v-col>
        <v-col>
          <v-btn color="primary" @click="selectPersonneMorale"
            >{{ $t('administration.personneMorale.cotisable.add') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="12">
          <v-data-table
            :headers="headersCotisables"
            :items="cotisables"
            :search="search"
            item-key="id"
            dense
            ref="cotisables"
          >
            <template #item.nomUsuel="{item}">
              <navigable-link
                :to="$liens().personneMorale(item.idPersonneMorale)"
              >
                {{ item.nomUsuel }}
              </navigable-link>
            </template>
            <template #item.raisonSociale="{item}">
              <navigable-link
                :to="$liens().personneMorale(item.idPersonneMorale)"
              >
                {{ item.raisonSociale }}
              </navigable-link>
            </template>
            <template #item.nombreCotisants="{item}">
              <a @click="lienRecherche(item)">
                {{ item.nombreCotisants }}
              </a>
            </template>
            <template #item.actions="{item}">
              <v-btn
                v-if="item.nombreCotisants == 0"
                small
                icon
                @click.stop="remove(item)"
              >
                <v-icon>mdi-trash-can</v-icon></v-btn
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn text @click="quit" :title="$t('button.quit')">{{
        this.$t('button.quit')
      }}</v-btn>

      <v-dialog v-model="control.confirmError" persistent max-width="50%">
        <v-card>
          <v-card-title class="error white--text">
            <v-icon color="white">mdi-alert</v-icon
            >{{ this.control.error.title }}
          </v-card-title>
          <v-card-text class="body-1">
            <p class="pt-4">
              {{ this.control.error.message }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="confirmError()">
              {{ $t('button.ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';
import toasted from '@/utils/toasted';

export default {
  props: {
    /** Titre de la page */
    title: {
      type: String,
      default: null,
    },
    /** L'API de communication avec le back */
    api: {},
    /** Les infos pour le retour vers le menu paramétrage */
    returnRoute: {},
  },
  data() {
    const datasourcePersonneMorale = new Datasource(
      'recherche/simple/personne-morale',
      {
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nomUsuel'],
        descending: [false],
        selectAll: this.selectAll,
        labelNamespace: 'recherche.rechercheSimple.personneMorale.list',
        args: {
          actif: true,
        },
        fields: [
          {
            value: 'nomUsuel',
            sortable: true,
          },
          '_add',
        ],
      },
    );
    const headersCotisables = [
      {
        text: this.$t(
          'administration.personneMorale.cotisable.list.headers.nomUsuel',
        ),
        value: 'nomUsuel',
        sortable: true,
      },
      {
        text: this.$t(
          'administration.personneMorale.cotisable.list.headers.raisonSociale',
        ),
        value: 'raisonSociale',
        sortable: true,
      },
      {
        text: this.$t(
          'administration.personneMorale.cotisable.list.headers.nombreCotisants',
        ),
        value: 'nombreCotisants',
        sortable: true,
      },
      {
        text: this.$t(
          'administration.personneMorale.cotisable.list.headers.actions',
        ),
        value: 'actions',
        sortable: false,
        align: 'center',
      },
    ];

    return {
      // Le datasource pour la dialog de recherche de personnes morales
      datasourcePersonneMorale,
      // Les nentêtes de la liste des cotisables
      headersCotisables,
      // La liste des cotisables
      cotisables: [],
      // Les champs de recherche
      search: null,

      // Pour la getsion d'erreurs
      control: {
        confirmError: false,
        error: {
          title: '',
          message: '',
        },
      },
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getValues();
  },
  computed: {},
  methods: {
    getValues() {
      this.$api('administration/cotisable/list')
        .get()
        .then(response => {
          this.cotisables = response.body;
        });
    },
    // Redirecetion vers la PM
    selectPersonneMorale() {
      this.$refs.dialogRecherchePersonneMorale.show();
    },
    // Redirection vers la recherche avancée pour savoir qui cotise à ce cotisable
    lienRecherche(item) {
      let infoRecherche = {
        titre: 'Cotise à : ' + item.nomUsuel,
        recherche: [
          {
            famille: 'PERSONNEMORALE',
            propriete: 'cotisable',
            type: 'cle',
            valeur: item.id,
          },
        ],
      };
      this.$router.push({
        name: 'recherche/rechercheavancee',
        params: {
          infoRecherche: infoRecherche,
          tab: 'personneMorale',
        },
      });
    },
    // Ajout d'une PM comme cotisable
    add(item) {
      this.$api('administration/cotisable/add/' + item.id)
        .put()
        .then(() => {
          toasted.info(
            'administration.personneMorale.cotisable.results.create.success',
          );
          this.getValues();
        })
        .catch(errors => {
          toasted.error(
            'administration.personneMorale.cotisable.results.create.error',
          );
          this.control.error.title = this.$t(
            'administration.personneMorale.cotisable.results.create.error',
          );
          var code =
            'administration.personneMorale.cotisable.results.create.errors.doublon';
          var nb = 0;
          if (
            Array.isArray(errors.globalErrors) &&
            errors.globalErrors.length > 0
          ) {
            var globalError = errors.globalErrors[0];
            if (
              Array.isArray(globalError.codes) &&
              globalError.codes.length > 0
            ) {
              code = globalError.codes[0];
            }
            if (
              Array.isArray(globalError.arguments) &&
              globalError.arguments.length > 0
            ) {
              nb = globalError.arguments[0];
            }
          }
          this.control.error.message = this.$tc(code, nb);
          this.control.confirmError = true;
        });
    },
    // Suppression du cotisable
    remove(item) {
      this.$api('administration/cotisable/remove/' + item.id)
        .put()
        .then(() => {
          toasted.info(
            'administration.personneMorale.cotisable.results.delete.success',
          );
          this.getValues();
        })
        .catch(errors => {
          toasted.error(
            'administration.personneMorale.cotisable.results.delete.error',
          );
          this.control.error.title = this.$t(
            'administration.personneMorale.cotisable.results.delete.error',
          );
          var code =
            'administration.personneMorale.cotisable.results.delete.errors.referenced';
          var nb = 0;
          if (
            Array.isArray(errors.globalErrors) &&
            errors.globalErrors.length > 0
          ) {
            var globalError = errors.globalErrors[0];
            if (
              Array.isArray(globalError.codes) &&
              globalError.codes.length > 0
            ) {
              code = globalError.codes[0];
            }
            if (
              Array.isArray(globalError.arguments) &&
              globalError.arguments.length > 0
            ) {
              nb = globalError.arguments[0];
            }
          }
          this.control.error.message = this.$tc(code, nb);
          this.control.confirmError = true;
        });
    },
    confirmError() {
      this.control.confirmError = false;
    },
    quit() {
      this.$router.replace(this.returnRoute);
    },
  },
};
</script>
